module.exports = __webpack_public_path__ + "static/media/Done_Button@3x.ed9d8205.png";